import React from "react";
import { Box, Select } from "@amzn/awsui-components-react";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import { Stage } from "../../../lusca-search-api/generated-src";
import { STAGE_OPTIONS } from "../../../constants";

interface StageSelectorProps {
  stage: Stage;
  setStage: (stage: Stage) => void;
}

export const StageSelector: React.FC<StageSelectorProps> = ({
  stage,
  setStage,
}) => {
  return (
    <SpaceBetween size="xs">
      <Box>Environment</Box>
      <Select
        selectedOption={{ label: stage, value: stage }}
        onChange={({ detail }) => {
          const newStage = (detail.selectedOption.value as Stage) || stage;
          setStage(newStage);
        }}
        options={STAGE_OPTIONS}
        selectedAriaLabel="Selected"
        placeholder="Select a stage"
        ariaRequired={true}
      />
    </SpaceBetween>
  );
};
